import { Mail } from 'lucide-react';

const TopBar = ({ config }) => {
  // Social links in correct order: X, Instagram, Facebook, TikTok, Truth Social, Getter, YouTube
  const socialLinks = [
    { icon: 'fa-x-twitter', label: 'X', url: 'https://x.com/securethevotemd' },
    { icon: 'fa-instagram', label: 'Instagram', url: 'https://www.instagram.com/securethevotemd/' },
    { icon: 'fa-facebook-f', label: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61558958704794' },
    { icon: 'fa-tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@securethevotemd?lang=en' },
    { icon: 'fa-t', label: 'Truth Social', url: 'https://truthsocial.com/@securethevotemd', isSvg: true, svgPath: '/icons/truth-social.svg' },
    { icon: 'fa-g', label: 'Getter', url: 'https://gettr.com/user/securethevotemd', isSvg: true, svgPath: '/icons/gettr.svg' },
    { icon: 'fa-youtube', label: 'YouTube', url: 'https://www.youtube.com/@SecuretheVoteMD' }
  ];

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 py-2"
      style={{ backgroundColor: '#F6BF58' }}
      data-testid="top-bar"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between">
          {/* Email */}
          <a 
            href={`mailto:${config?.contact_email || 'info@securethevotemd.com'}`}
            className="flex items-center gap-2 text-white text-sm hover:opacity-80 transition-opacity"
            data-testid="topbar-email"
          >
            <Mail size={16} />
            <span>{config?.contact_email || 'info@securethevotemd.com'}</span>
          </a>

          {/* Social Icons */}
          <div className="flex items-center gap-4" data-testid="topbar-social">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:opacity-70 transition-opacity"
                aria-label={social.label}
                data-testid={`social-icon-${index}`}
              >
                {social.isSvg ? (
                  <img src={`${process.env.PUBLIC_URL || ""}${social.svgPath}`} alt={social.label} className="h-[16px] w-auto" style={{ filter: 'brightness(0) invert(1)' }} />
                ) : (
                  <i className={`fa-brands ${social.icon}`}></i>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
